/* yt-quiz.js — questionnaire v2 (18 Oct 2026, second pass).
 * A static stepper over assets/yt-quiz-bank.json: the intro IS question one
 * (the six in-house goals as tiles), visibility rules run in the browser, and
 * the only request is the last one — POST /apps/yutrients/quiz/formulate —
 * after which the customer lands straight on the product page with the
 * add-ons pre-ticked. Events: GA4 via window.ytTrack (no personal data) and
 * the first-party beacon as virtual page views (/quiz/<question id>).
 * Spec: docs/02-formulator/questionnaire-v2-plan.md */
(function () {
  'use strict';
  var root = document.querySelector('[data-yt-quiz]');
  if (!root) return;
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var STORE_KEY = 'yt_quiz_v2';
  var el = {
    intro: $('[data-ytq-intro]'), stepper: $('[data-ytq-stepper]'), building: $('[data-ytq-building]'),
    tiles: $('[data-ytq-intro-tiles]'), resume: $('[data-ytq-resume]'), sections: $('[data-ytq-sections]'), count: $('[data-ytq-count]'),
    stage: $('[data-ytq-stage]'), sofar: $('[data-ytq-sofar]'), back: $('[data-ytq-back]'), skip: $('[data-ytq-skip]'), next: $('[data-ytq-next]'),
    error: $('[data-ytq-error]'), steps: $('[data-ytq-steps]'), experts: $('[data-ytq-experts]'), bar: $('[data-ytq-bar]')
  };
  var bank = null, answers = {}, idx = 0, visible = [], seen = {};
  var units = { h: 'ft in', w: 'kg' }; // UK defaults (Lucas): feet and inches, kilograms; remembered per viewer

  // ── analytics ──────────────────────────────────────────────────────────
  function track(name, params) { try { if (window.ytTrack) window.ytTrack(name, params || {}); } catch (e) {} }
  function beacon(path) {
    try {
      if (!navigator.sendBeacon) return;
      navigator.sendBeacon('/apps/yutrients/track', new Blob([JSON.stringify({ path: path, referrer: location.pathname, consent: 'unknown', device: window.innerWidth < 768 ? 'mobile' : (window.innerWidth < 1024 ? 'tablet' : 'desktop') })], { type: 'text/plain' }));
    } catch (e) {}
  }

  // ── storage (per-viewer convenience only) ─────────────────────────────
  function save() { try { localStorage.setItem(STORE_KEY, JSON.stringify({ v: bank.version, answers: answers, idx: idx, units: units, t: Date.now() })); } catch (e) {} }
  function load() { try { var s = JSON.parse(localStorage.getItem(STORE_KEY) || 'null'); return s && s.v === bank.version && s.answers ? s : null; } catch (e) { return null; } }
  function clear() { try { localStorage.removeItem(STORE_KEY); } catch (e) {} }

  // ── visibility ────────────────────────────────────────────────────────
  function goalId() { return typeof answers['goal.main'] === 'string' ? answers['goal.main'] : ''; }
  function count(v) { return Array.isArray(v) ? v.length : (v ? 1 : 0); }
  function shows(q) {
    var g = goalId();
    if (q.goal && q.goal.indexOf(g) < 0) return false;
    if (q.hide_if_goal && q.hide_if_goal.indexOf(g) >= 0) return false;
    var c = q.show_if; if (!c) return true;
    var v = answers[c.q];
    if (c.is !== undefined) return v === c.is;
    if (c.in) return c.in.indexOf(v) >= 0;
    if (c.not !== undefined) return Array.isArray(v) ? (v.length > 0 && v.indexOf(c.not) < 0) : (v !== undefined && v !== c.not);
    if (c.min_count !== undefined) return count(v) >= c.min_count;
    return true;
  }
  function recompute() {
    visible = bank.questions.filter(shows);
    var ids = {}; visible.forEach(function (q) { ids[q.id] = 1; });
    Object.keys(answers).forEach(function (k) { if (!ids[k]) delete answers[k]; });
  }
  function current() { return visible[idx]; }
  function goal() { return (bank.goals || []).filter(function (x) { return x.id === goalId(); })[0]; }
  function sectionLabel(sec) { if (sec.id !== 'focus') return sec.label; var g = goal(); return g ? g.focus_label : sec.label; }
  function answered(q) {
    var v = answers[q.id];
    if (q.type === 'multi') return Array.isArray(v) && v.length > 0;
    if (q.type === 'rank') return Array.isArray(v) && v.length === rankItems(q).length;
    if (q.type === 'profile') return !!(v && v.dob && v.height_cm && v.weight_kg);
    return typeof v === 'string' && v.length > 0;
  }
  function rankItems(q) {
    var from = answers[q.from_q]; if (!Array.isArray(from)) return [];
    var src = bank.questions.filter(function (x) { return x.id === q.from_q; })[0];
    return from.map(function (id) { return (src.options || []).filter(function (o) { return o.id === id; })[0]; }).filter(Boolean);
  }

  // ── render ────────────────────────────────────────────────────────────
  function h(tag, cls, text) { var n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; }
  function renderSections() {
    var q = current(); var active = q ? q.section : bank.sections[0].id; var seenActive = false; el.sections.innerHTML = '';
    bank.sections.forEach(function (sec) {
      var li = h('li', '', sectionLabel(sec));
      if (sec.id === active) { li.className = 'is-active'; seenActive = true; } else if (!seenActive) li.className = 'is-done';
      el.sections.appendChild(li);
    });
  }
  function renderCount() {
    var q = current(); var sec = q ? bank.sections.filter(function (s) { return s.id === q.section; })[0] : null;
    el.count.textContent = (sec ? sectionLabel(sec) + ' · ' : '') + 'Question ' + (idx + 1) + ' of about ' + visible.length;
  }
  function renderSoFar() {
    var q = current(); var g = goal();
    var extra = Array.isArray(answers['goal.rank']) ? answers['goal.rank'] : (Array.isArray(answers['goal.secondary']) ? answers['goal.secondary'] : []);
    var sq = bank.questions.filter(function (x) { return x.id === 'goal.secondary'; })[0];
    var names = (g ? [g.label] : []).concat(extra.map(function (id) { var o = (sq.options || []).filter(function (x) { return x.id === id; })[0]; return o ? o.label : id; }));
    if (!q || q.section === 'goal' || !names.length) { el.sofar.hidden = true; return; }
    el.sofar.hidden = false;
    el.sofar.innerHTML = '<b>Building for:</b> ' + names.map(function (s) { return s.replace(/</g, '&lt;'); }).join(' · ') + ' <span style="color:#6b6b68">· ' + Object.keys(answers).length + ' answers so far</span>';
  }
  function renderQuestion() {
    var q = current(); el.stage.innerHTML = ''; el.error.hidden = true;
    if (!q) return;
    var sec = bank.sections.filter(function (s) { return s.id === q.section; })[0];
    el.stage.appendChild(h('p', 'ytq__eyebrow', sectionLabel(sec)));
    el.stage.appendChild(h('h2', 'ytq__q', q.q));
    if (q.help) el.stage.appendChild(h('p', 'ytq__help', q.help));
    if (q.why) { var w = h('div', 'ytq__why'); w.appendChild(h('b', '', 'Why we ask')); w.appendChild(document.createTextNode(q.why)); el.stage.appendChild(w); }
    if (q.type === 'single' || q.type === 'multi') renderOptions(q, el.stage);
    else if (q.type === 'rank') renderRank(q);
    else if (q.type === 'profile') renderProfile(q);
    el.skip.hidden = !q.optional;
    el.back.disabled = false;
    syncNext();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  function optionsFor(q) { var opts = q.options || []; if (q.exclude_main) opts = opts.filter(function (o) { return o.id !== goalId(); }); var hide = (q.hide_by_goal || {})[goalId()] || []; if (hide.length) opts = opts.filter(function (o) { return hide.indexOf(o.id) < 0; }); return opts; }
  function renderOptions(q, into, onPick) {
    var n = optionsFor(q).length;
    var list = h('ul', 'ytq__opts' + (q.layout === 'tiles' ? ' ytq__opts--tiles' : q.layout === 'grid' ? (n <= 4 ? ' ytq__opts--grid ytq__opts--four' : ' ytq__opts--grid') : ''));
    var multi = q.type === 'multi';
    optionsFor(q).forEach(function (o) {
      var li = h('li'); var b = h('button', 'ytq__opt' + (multi ? ' ytq__opt--multi' : '')); b.type = 'button'; b.setAttribute('data-opt', o.id);
      b.setAttribute('role', multi ? 'checkbox' : 'radio');
      var mark = h('span', 'ytq__opt-mark', '✓'); mark.setAttribute('aria-hidden', 'true');
      var text = h('span', 'ytq__opt-text'); text.appendChild(h('span', 'ytq__opt-label', o.label)); if (o.sub) text.appendChild(h('span', 'ytq__opt-sub', o.sub));
      b.appendChild(mark); b.appendChild(text);
      b.addEventListener('click', function () {
        if (multi) {
          var cur = Array.isArray(answers[q.id]) ? answers[q.id].slice() : [];
          var none = (q.options || []).filter(function (x) { return x.id === 'none' || x.id === 'na'; }).map(function (x) { return x.id; });
          if (cur.indexOf(o.id) >= 0) cur = cur.filter(function (x) { return x !== o.id; });
          else { if (none.indexOf(o.id) >= 0) cur = [o.id]; else cur = cur.filter(function (x) { return none.indexOf(x) < 0; }).concat([o.id]); if (q.max && cur.length > q.max) cur = cur.slice(cur.length - q.max); }
          answers[q.id] = cur;
        } else { answers[q.id] = o.id; }
        recompute(); paintOptions(q, into); syncNext(); save();
        if (onPick) { onPick(); return; }
        if (!multi) setTimeout(next, 180); // a single tap moves on — the tempo of the whole thing
      });
      li.appendChild(b); list.appendChild(li);
    });
    into.appendChild(list); paintOptions(q, into);
  }
  function paintOptions(q, into) {
    var v = answers[q.id]; var set = Array.isArray(v) ? v : (v ? [v] : []);
    (into || el.stage).querySelectorAll('[data-opt]').forEach(function (b) {
      var on = set.indexOf(b.getAttribute('data-opt')) >= 0; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false');
      if (q.type === 'rank') { var k = set.indexOf(b.getAttribute('data-opt')); b.querySelector('.ytq__opt-mark').textContent = k >= 0 ? String(k + 1) : ''; }
    });
  }
  function renderRank(q) {
    var items = rankItems(q);
    if (items.length < 2) { answers[q.id] = items.map(function (o) { return o.id; }); return; }
    var list = h('ul', 'ytq__opts ytq__opts--grid');
    items.forEach(function (o) {
      var li = h('li'); var b = h('button', 'ytq__opt ytq__opt--multi'); b.type = 'button'; b.setAttribute('data-opt', o.id);
      var mark = h('span', 'ytq__opt-mark', ''); var text = h('span', 'ytq__opt-text'); text.appendChild(h('span', 'ytq__opt-label', o.label));
      b.appendChild(mark); b.appendChild(text);
      b.addEventListener('click', function () {
        var cur = Array.isArray(answers[q.id]) ? answers[q.id].slice() : [];
        if (cur.indexOf(o.id) >= 0) cur = cur.filter(function (x) { return x !== o.id; }); else cur.push(o.id);
        answers[q.id] = cur; paintOptions(q); syncNext(); save();
        if (cur.length === items.length) setTimeout(next, 220);
      });
      li.appendChild(b); list.appendChild(li);
    });
    el.stage.appendChild(list); paintOptions(q);
  }

  // Profile: birthday (day · month · year), height (ft in | cm), weight (kg | st lb).
  // Every control is a native select — a wheel on phones, never a keyboard
  // (Lucas, 18 Oct: typing numbers with the keyboard up was clunky). Stored
  // metric; the unit switch only changes which wheels are shown.
  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  function range(a, b, step) { var out = []; for (var v = a; v <= b; v += (step || 1)) out.push(v); return out; }
  function renderProfile(q) {
    var cur = answers[q.id] || {}; var wrap = h('div', 'ytq__profile');
    function sel(opts, value, placeholder, aria) {
      var w = h('div', 'ytq__select'); var s = h('select'); s.setAttribute('aria-label', aria);
      var p = h('option', '', placeholder); p.value = ''; p.disabled = true; if (value == null || value === '') p.selected = true; s.appendChild(p);
      opts.forEach(function (o) { var x = h('option', '', o.label); x.value = o.value; if (String(o.value) === String(value)) x.selected = true; s.appendChild(x); });
      w.appendChild(s); return { wrap: w, select: s };
    }
    function field(label, key, a, b) {
      var f = h('div', 'ytq__field'); var head = h('div', 'ytq__field-head'); head.appendChild(h('span', 'ytq__field-label', label));
      if (key) {
        var tg = h('div', 'ytq__units'); tg.setAttribute('role', 'tablist');
        [[a[0], a[1]], [b[0], b[1]]].forEach(function (pair) {
          var btn = h('button', units[key] === pair[0] ? 'is-on' : '', pair[1]); btn.type = 'button'; btn.setAttribute('role', 'tab'); btn.setAttribute('aria-selected', String(units[key] === pair[0]));
          btn.addEventListener('click', function () { if (units[key] === pair[0]) return; units[key] = pair[0]; save(); renderProfile(q); });
          tg.appendChild(btn);
        });
        head.appendChild(tg);
      }
      f.appendChild(head); return f;
    }
    function setPart(k, v) { var o = answers[q.id] || {}; if (v === undefined) delete o[k]; else o[k] = v; answers[q.id] = o; syncNext(); save(); }
    // birthday
    var dob = (cur.dob || '').split('-'); var yNow = new Date().getFullYear();
    var fb = field('Birthday'); var rb = h('div', 'ytq__row ytq__row--3');
    var sd = sel(range(1, 31).map(function (d) { return { value: String(d).padStart(2, '0'), label: String(d) }; }), dob[2], 'Day', 'Day of birth');
    var sm = sel(MONTHS.map(function (m, i) { return { value: String(i + 1).padStart(2, '0'), label: m }; }), dob[1], 'Month', 'Month of birth');
    var sy = sel(range(yNow - 100, yNow - 16).reverse().map(function (y) { return { value: String(y), label: String(y) }; }), dob[0], 'Year', 'Year of birth');
    rb.appendChild(sd.wrap); rb.appendChild(sm.wrap); rb.appendChild(sy.wrap); fb.appendChild(rb); wrap.appendChild(fb);
    function setDob() { setPart('dob', (sd.select.value && sm.select.value && sy.select.value) ? sy.select.value + '-' + sm.select.value + '-' + sd.select.value : undefined); }
    [sd, sm, sy].forEach(function (x) { x.select.addEventListener('change', setDob); });
    // height
    var fh = field('Height', 'h', ['ft in', 'ft / in'], ['cm', 'cm']);
    if (units.h === 'cm') {
      var rh = h('div', 'ytq__row ytq__row--1');
      var hc = sel(range(120, 220).map(function (v) { return { value: v, label: v + ' cm' }; }), cur.height_cm ? Math.round(cur.height_cm) : '', 'Height', 'Height in centimetres');
      hc.select.addEventListener('change', function () { setPart('height_cm', hc.select.value ? Number(hc.select.value) : undefined); });
      rh.appendChild(hc.wrap); fh.appendChild(rh);
    } else {
      var rh2 = h('div', 'ytq__row ytq__row--2'); var totalIn = cur.height_cm ? Math.round(cur.height_cm / 2.54) : 0;
      var ft = sel(range(4, 7).map(function (v) { return { value: v, label: v + ' ft' }; }), totalIn ? Math.floor(totalIn / 12) : '', 'Feet', 'Height, feet');
      var inch = sel(range(0, 11).map(function (v) { return { value: v, label: v + ' in' }; }), totalIn ? String(totalIn % 12) : '', 'Inches', 'Height, inches');
      var setH = function () { if (ft.select.value === '' || inch.select.value === '') { setPart('height_cm', undefined); return; } setPart('height_cm', Math.round((Number(ft.select.value) * 12 + Number(inch.select.value)) * 2.54)); };
      ft.select.addEventListener('change', setH); inch.select.addEventListener('change', setH);
      rh2.appendChild(ft.wrap); rh2.appendChild(inch.wrap); fh.appendChild(rh2);
    }
    wrap.appendChild(fh);
    // weight
    var fw = field('Weight', 'w', ['kg', 'kg'], ['st lb', 'st / lb']);
    if (units.w === 'kg') {
      var rw = h('div', 'ytq__row ytq__row--1');
      var wk = sel(range(35, 200).map(function (v) { return { value: v, label: v + ' kg' }; }), cur.weight_kg ? Math.round(cur.weight_kg) : '', 'Weight', 'Weight in kilograms');
      wk.select.addEventListener('change', function () { setPart('weight_kg', wk.select.value ? Number(wk.select.value) : undefined); });
      rw.appendChild(wk.wrap); fw.appendChild(rw);
    } else {
      var rw2 = h('div', 'ytq__row ytq__row--2'); var totalLb = cur.weight_kg ? Math.round(cur.weight_kg * 2.20462) : 0;
      var st = sel(range(5, 30).map(function (v) { return { value: v, label: v + ' st' }; }), totalLb ? Math.floor(totalLb / 14) : '', 'Stone', 'Weight, stone');
      var lb = sel(range(0, 13).map(function (v) { return { value: v, label: v + ' lb' }; }), totalLb ? String(totalLb % 14) : '', 'Pounds', 'Weight, pounds');
      var setW = function () { if (st.select.value === '' || lb.select.value === '') { setPart('weight_kg', undefined); return; } setPart('weight_kg', Math.round((Number(st.select.value) * 14 + Number(lb.select.value)) * 0.453592 * 10) / 10); };
      st.select.addEventListener('change', setW); lb.select.addEventListener('change', setW);
      rw2.appendChild(st.wrap); rw2.appendChild(lb.wrap); fw.appendChild(rw2);
    }
    wrap.appendChild(fw);
    var prev = el.stage.querySelector('.ytq__profile');
    if (prev) el.stage.replaceChild(wrap, prev); else el.stage.appendChild(wrap);
  }
  function syncNext() {
    var q = current(); if (!q) return;
    var last = idx === visible.length - 1;
    el.next.textContent = last ? 'Build my blend' : 'Continue';
    el.next.disabled = !(answered(q) || (q.optional && last));
  }
  function render() { recompute(); if (idx >= visible.length) idx = visible.length - 1; if (idx < 1) idx = 1; renderSections(); renderCount(); renderQuestion(); }

  // ── navigation ────────────────────────────────────────────────────────
  function logStep() { var q = current(); if (!q || seen[q.id]) return; seen[q.id] = 1; beacon('/quiz/' + q.id); track('quiz_step', { section: q.section, qid: q.id, n: idx + 1, goal: goalId() }); }
  function next() {
    var q = current(); if (!q) return;
    if (!answered(q) && !q.optional) return;
    recompute();
    if (idx >= visible.length - 1) { finish(); return; }
    idx += 1; save(); render(); logStep();
  }
  function back() {
    if (idx <= 1) { show(el.intro); idx = 0; return; } // question one lives on the intro
    idx -= 1; render(); track('quiz_back', { qid: current().id });
  }
  function skip() { var q = current(); if (!q || !q.optional) return; delete answers[q.id]; next(); }
  el.next.addEventListener('click', next); el.back.addEventListener('click', back); el.skip.addEventListener('click', skip);
  document.addEventListener('keydown', function (e) { if (e.key === 'Enter' && !el.stepper.hidden && !el.next.disabled && e.target.tagName !== 'BUTTON' && e.target.tagName !== 'SELECT') next(); });

  function show(screen) { [el.intro, el.stepper, el.building].forEach(function (s) { s.hidden = s !== screen; }); window.scrollTo(0, 0); }
  function begin(resumed) {
    recompute(); if (!resumed) idx = 1; seen = {};
    show(el.stepper); render(); logStep(); beacon('/quiz/_start'); track('quiz_start', { resumed: !!resumed, goal: goalId() });
  }

  // ── finish: the one network call, then straight to the product page ──
  function finish() {
    show(el.building); beacon('/quiz/_complete'); track('quiz_complete', { answers: Object.keys(answers).length, goal: goalId() });
    var steps = el.steps.querySelectorAll('li'); var experts = el.experts.querySelectorAll('li'); var k = 0; var t0 = Date.now(); var EXPECT = 22000;
    function paint() { steps.forEach(function (li, i) { li.classList.toggle('is-done', i < k); li.classList.toggle('is-on', i === k); }); experts.forEach(function (li, i) { li.classList.toggle('is-on', i <= k); }); }
    paint();
    var tick = setInterval(function () { if (k < steps.length - 1) { k++; paint(); } var p = Math.min(92, Math.round(((Date.now() - t0) / EXPECT) * 100)); el.bar.style.width = p + '%'; }, 1000);
    var payload = { answers: {} }; Object.keys(answers).forEach(function (kk) { payload.answers[kk] = answers[kk]; });
    fetch(root.dataset.proxy + '/quiz/formulate', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok || !res.j || !res.j.formula_id) throw new Error((res.j && res.j.error && res.j.error.message) || 'Something went wrong building your blend.');
        clearInterval(tick); k = steps.length; paint(); el.bar.style.width = '100%';
        track('quiz_formulate', { ms: Date.now() - t0, base: res.j.base.slug, add_ons: res.j.add_ons.length, monthly: res.j.monthly_sub });
        beacon('/quiz/_result'); clear();
        setTimeout(function () { window.location.href = res.j.pdp_url + '&src=quiz'; }, 700);
      })
      .catch(function (err) {
        clearInterval(tick); show(el.stepper); render();
        el.error.hidden = false; el.error.textContent = (err && err.message ? err.message : 'Something went wrong building your blend.') + ' Try "Build my blend" again.';
        track('quiz_error', { ms: Date.now() - t0 });
      });
  }

  // ── boot ──────────────────────────────────────────────────────────────
  fetch(root.dataset.bank, { credentials: 'omit' }).then(function (r) { return r.json(); }).then(function (b) {
    bank = b; var intro = b.intro || {};
    if (intro.eyebrow) $('[data-ytq-intro-eyebrow]').textContent = intro.eyebrow;
    var q1 = b.questions.filter(function (q) { return q.id === 'goal.main'; })[0];
    if (q1) $('[data-ytq-intro-heading]').textContent = q1.q;
    if (intro.sub) $('[data-ytq-intro-sub]').textContent = intro.sub;
    if (intro.note) $('[data-ytq-intro-note]').textContent = intro.note;
    var chips = $('[data-ytq-intro-chips]'); (intro.chips || []).forEach(function (c) { chips.appendChild(h('li', '', c)); });
    // the team on the building screen
    (b.experts || []).forEach(function (x) { var li = h('li'); var img = h('img'); img.src = root.dataset.assetBase + x.asset; img.alt = ''; img.width = 72; img.height = 72; img.loading = 'lazy'; li.appendChild(img); li.appendChild(h('b', '', x.name)); li.appendChild(h('span', '', x.role)); el.experts.appendChild(li); });
    (b.building_steps || []).forEach(function (s) { el.steps.appendChild(h('li', '', s)); });
    // question one, on the intro
    var holder = el.tiles.parentNode; var tmp = h('div'); renderOptions(q1, tmp, function () { answers = { 'goal.main': answers['goal.main'] }; begin(false); });
    holder.replaceChild(tmp.firstChild, el.tiles); el.tiles = holder.querySelector('.ytq__opts--tiles');
    var saved = load();
    if (saved && Object.keys(saved.answers).length > 1) {
      el.resume.hidden = false;
      el.resume.addEventListener('click', function () { answers = saved.answers; units = saved.units || units; idx = Math.max(1, saved.idx || 1); begin(true); });
    }
  }).catch(function () { $('[data-ytq-intro-heading]').textContent = 'The questionnaire is not available right now.'; });
})();
